// src/utils/programmeDetails.js
import bioNDImg from "../assets/images/luth-logo-16x16.png";
// import anaesImg from "../assets/logos/anaesthetic.png";
import nurseImg from "../assets/images/luth-logo-16x16.png";
// …

export default {
  "Biomedical Engineering (ND)": {
    image: bioNDImg,
    // …
  },
  "Department of Nursing Sciences": {
    image: nurseImg,
  }
  // …
};
